import { render } from "./FeatureUnavailableToTeam.vue?vue&type=template&id=5da2ec24"
import script from "./FeatureUnavailableToTeam.vue?vue&type=script&lang=js"
export * from "./FeatureUnavailableToTeam.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__